import { setState } from 'Utils/Store';

export const contentCardsInitialState = {
  allContentCards: [],
};

export const setContentCards = (cards) => setState('contentCards', { allContentCards: cards });
